G.UI_Life = function(x,y) {
	
	Phaser.Group.call(this,game);

	this.x = G.l(x);
	this.y = G.l(y);

  this.glow = G.makeImage(0, 0, "popup_lighht", 0.5, this);
  this.glow.blendMode = 1;
  this.glow.alpha = 0.2;

  // let shadowDistance = 3;
  // let heartShadow = G.makeImage(shadowDistance, shadowDistance, "heart", 0.5, this);
  // heartShadow.tint = 0;
  // heartShadow.alpha = 0.3;
  // heartShadow.scale.set(lifeIconScale, lifeIconScale);
	this.lifeIcon = new G.Button(0, 0, "heart", function() {
    
    if (G.saveState.getLives() == 0 && G.saveState.getUnlimitedLivesSec() == 0) {
      G.sb("pushWindow").dispatch(
        [
          "notEnoughLives"
        ],
        false,
        G.WindowMgr.LayerNames.AboveHighScorePanel
      );
    } else {
      G.sb("openLifeTransactionsMenu").dispatch();
    }
  },this);
  let lifeIconScale = 52 / this.lifeIcon.height;
  this.lifeIcon.scale.set(lifeIconScale, lifeIconScale);

  this.lifeIconUnlimited = G.makeImage(0, 0, "heart_unlimited", 0.5, this);
  game.add.tween(this.lifeIconUnlimited.scale)
    .to({x: 1.1, y: 1.1}, 1000, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);
	// this.lifeIcon.visible = false;
	this.add(this.lifeIcon);

  this.prevStatus = null;

	this.currentLivesNr = G.saveState.getLives();
	this.livesMax = G.json.settings.livesMax;

  this.livesNrTxt = new G.Text(G.OMTsettings.elements.UI_Life.livesNrTxt.x, G.OMTsettings.elements.UI_Life.livesNrTxt.y, this.currentLivesNr.toString(), {
    style: "font-white",
    fontSize: "40px",
  }, 0.5, 150);
	this.add(this.livesNrTxt);

  this.timer = new G.TextTimer(G.OMTsettings.elements.UI_Life.timerTxt.x, G.OMTsettings.elements.UI_Life.timerTxt.y, 0, G.OMTsettings.elements.UI_Life.timerTxt.style, 0.5, 140, "ms");
  this.add(this.timer);

  this.unlimitedTimer = new G.TextTimer(G.OMTsettings.elements.UI_Life.unlimitedTimerTxt.x, G.OMTsettings.elements.UI_Life.unlimitedTimerTxt.y, 0, G.OMTsettings.elements.UI_Life.unlimitedTimerTxt.style, 0.5, 140, "hms");
  this.add(this.unlimitedTimer);

  this.timerMax = new G.Text(G.OMTsettings.elements.UI_Life.timerMaxTxt.x, G.OMTsettings.elements.UI_Life.timerMaxTxt.y, OMT.language.getText('Max'), G.OMTsettings.elements.UI_Life.timerMaxTxt.style, 0.5, 100);
	this.add(this.timerMax);

	this.timer.start();

	G.sb("onWallClockTimeUpdate").add(this.onTickUpdate,this);
	G.sb("onLifeAdded").add(this.onTickUpdate,this);

  G.sb("onLifeTimerUpdate").add(this.timer.setSecLeft, this.timer);
  G.sb("onUnlimitedLivesChanged").add(this.unlimitedTimer.setSecLeft, this.unlimitedTimer);

	G.sb("onWindowOpened").add(this.lockInput,this);
	G.sb("onAllWindowsClosed").add(this.unlockInput,this);


};

G.UI_Life.prototype = Object.create(Phaser.Group.prototype);

G.UI_Life.prototype.onTickUpdate = function(){

	var newCurrentLives = G.saveState.getLives();

	if (this.currentLivesNr !== newCurrentLives) {
		this.currentLivesNr = newCurrentLives;
		this.livesNrTxt.setText(this.currentLivesNr.toString());
	}

};

G.UI_Life.prototype.update = function() {
  this.glow.angle++;
  var status;
  if (G.saveState.getUnlimitedLivesSec() > 0) {
    status = "unlimited";
  } else if (this.currentLivesNr < this.livesMax) {
    status = "normal";
  } else {
    status = "max";
  }

  if (status !== this.prevStatus) {
    switch (status) {
      case "max":
        this.showMax();
        break;
      case "normal":
        this.showNormal();
        break;
      case "unlimited":
        this.showUnlimited();
        break;
    }
  }

  this.prevStatus = status;

};

G.UI_Life.prototype.showUnlimited = function() {
  this.glow.visible = true;
  this.timer.visible = false;
  this.lifeIconUnlimited.visible = true;
  this.lifeIcon.visible = false;
  this.unlimitedTimer.visible = true;
  this.unlimitedTimer.start(G.saveState.getUnlimitedLivesSec());
  this.timerMax.visible = false;
  this.timer.visible = false;
  this.livesNrTxt.visible = false;
};

G.UI_Life.prototype.showMax = function() {
  this.glow.visible = false;
  this.timer.visible = false;
  this.lifeIconUnlimited.visible = false;
  this.unlimitedTimer.visible = false;
  this.timerMax.visible = true;
  this.timer.visible = false;
  this.lifeIcon.visible = true;
  this.lifeIcon.inputEnabled = false;
  this.livesNrTxt.visible = true;
};

G.UI_Life.prototype.showNormal = function() {
  this.glow.visible = false;
  this.timer.visible = true;
  this.lifeIconUnlimited.visible = false;
  this.unlimitedTimer.visible = false;
  this.timerMax.visible = false;
  this.timer.visible = true;
  this.lifeIcon.inputEnabled = window.OMT.feature.isGiftingSupported();
  this.lifeIcon.visible = true;
  this.livesNrTxt.visible = true;
};

G.UI_Life.prototype.lockInput = function() {
	this.ignoreChildInput = true;
};

G.UI_Life.prototype.unlockInput = function() {
	this.ignoreChildInput = false;
}
